export const directionsUrl = (lat, lng) =>
  `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`;


import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("pt_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const TORPIGNATTARA = [41.8768, 12.5408];

export function minutesLeft(leaveAt, now) {
  return Math.round((new Date(leaveAt).getTime() - now) / 60000);
}

export function formatLeft(leaveAt, now) {
  const ms = new Date(leaveAt).getTime() - now;
  if (ms <= 0) return "Ora";
  const m = Math.floor(ms / 60000);
  const s = Math.floor((ms % 60000) / 1000);
  return m > 0 ? `${m} min` : `${s}s`;
}

export const STATUS_LABEL = {
  active: "Disponibile",
  reserved: "Prenotato",
  completed: "Completato",
  cancelled: "Annullato",
};
